export enum PrivilegeArea {
    NONE = 0,
    SITE = 1,
    COUNTY = 2,
    COMPANY = 3,
    EQUIPMENT = 4
}